import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Seo } from "../lib/seo";
import { ArticleCard } from "../components/blog/ArticleCard";
import { Loader2 } from "lucide-react";

export default function BlogIndexPage() {
  const [articles, setArticles] = useState(null);
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  useEffect(() => {
    api.get("/articles", { params: { limit: 100 } }).then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);

  return (
    <div className="bg-[#F4F8FF] min-h-screen">
      <Seo
        title="Blog | Advanced Post Graduate Excellence"
        description="Articoli e approfondimenti sui corsi di odontoiatria, restauri estetici, faccette in composito e formazione clinica in Italia."
        canonical={`${origin}/blog`}
      />
      <section className="relative isolate overflow-hidden bg-[#0B1220]">
        <div className="grid-overlay absolute inset-0 pointer-events-none" />
        <div className="absolute -top-24 -right-24 h-[520px] w-[520px] rounded-full bg-[#1452F0]/25 blur-[130px] pointer-events-none" />
        <div className="relative px-6 md:px-12 max-w-[1400px] mx-auto pt-20 pb-16">
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-[#5B9DFF]">Editoriale</span>
          <h1 className="font-heading font-light tracking-tight leading-[0.95] mt-4 text-5xl lg:text-6xl silver-text">
            Blog & approfondimenti
          </h1>
          <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-[#9AA7BD] max-w-2xl">
            Guide, tecniche cliniche e novità dai nostri corsi di formazione odontoiatrica.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 max-w-[1400px] mx-auto py-16 md:py-20">
        {articles === null ? (
          <div className="py-20 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#1452F0]" /></div>
        ) : articles.length === 0 ? (
          <div data-testid="blog-empty" className="py-20 text-center text-[#5C6678]">
            <p className="font-heading text-2xl text-[#0B1220]">Nessun articolo pubblicato</p>
            <p className="mt-2">Torna presto per i nostri approfondimenti.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="blog-grid">
            {articles.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
